/**
 * RFC 9457 problem details as returned by the API (see apps/api core/errors.py).
 * The generated client throws the parsed response body, so errors are plain objects.
 */
export interface Problem {
  type: string;
  title: string;
  status: number;
  code: string;
  detail?: string;
  instance?: string;
  request_id?: string;
}

export function isProblem(value: unknown): value is Problem {
  if (typeof value !== 'object' || value === null) return false;
  const candidate = value as Partial<Record<keyof Problem, unknown>>;
  return typeof candidate.status === 'number' && typeof candidate.code === 'string';
}

export function isClientError(error: unknown): boolean {
  return isProblem(error) && error.status >= 400 && error.status < 500;
}

/** i18n key for an error; unknown errors map to a generic message. */
export function problemMessageKey(error: unknown): `errors.${string}` {
  return isProblem(error) ? `errors.${error.code}` : 'errors.unknown';
}
